/**
 * @generated SignedSource<<76040c0c3cdf82c6ffda2c06fea217eb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification$data = {
  readonly projectInviterNotification: {
    readonly id: string;
    readonly slackChannel: {
      readonly isEnabled: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification";
};
export type slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification$key = {
  readonly " $data"?: slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification$data;
  readonly " $fragmentSpreads": FragmentRefs<"slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "slackInviterNotif_personalSettingsDigestNotifications_SlackInviterNotification",
  "selections": [
    {
      "concreteType": "JiraNotificationPreference",
      "kind": "LinkedField",
      "name": "projectInviterNotification",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "projectInviterNotification.id"
        },
        {
          "concreteType": "JiraNotificationChannel",
          "kind": "LinkedField",
          "name": "slackChannel",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isEnabled"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraNotificationPreferences"
};

(node as any).hash = "9413b48e94223170556a58bfbece4314";

export default node;
